(function () {
  function hydrateDrawers() {
    document
      .querySelectorAll(`.nss-science-card template[nss-science-drawer-template]`)
      .forEach((tpl) => {
        const drawerEl = tpl.content.firstElementChild;
        if (!drawerEl) return;
        const id = drawerEl.getAttribute(`nss-drawer-id`);
        if (id && !document.querySelector(`body > nss-drawer[nss-drawer-id="${CSS.escape(id)}"]`)) {
          document.body.appendChild(drawerEl.cloneNode(true));
        }
        tpl.remove();
      });
  }

  document.addEventListener(`click`, (e) => {
    const studiesEl = e.target.closest(`[nss-science-studies]`);
    if (studiesEl) {
      e.preventDefault();
      e.stopPropagation();
      const drawerEl = document.querySelector(
        `nss-drawer[nss-drawer-id="${CSS.escape(studiesEl.getAttribute(`nss-science-studies`))}"]`
      );
      if (drawerEl && typeof drawerEl.open === `function`) drawerEl.open();
      return;
    }

    const barEl = e.target.closest(`[nss-science-bar]`);
    if (!barEl) return;
    const cardEl = barEl.closest(`.nss-science-card`);
    if (cardEl) cardEl.classList.toggle(`is-open`);
  });

  if (document.readyState === `loading`) {
    document.addEventListener(`DOMContentLoaded`, hydrateDrawers);
  } else {
    hydrateDrawers();
  }
})();
